import { render, staticRenderFns } from "./PpobHistory.vue?vue&type=template&id=443965f1"
import script from "./PpobHistory.vue?vue&type=script&lang=js"
export * from "./PpobHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports